export default {"src":"/_next/static/media/bcc.c10b5e96.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};